import React, { useContext, useEffect, useRef, useState } from "react";
import { Canvas, useThree } from "@react-three/fiber";
import * as THREE from "three";
import { OrbitControls, Center, Html, PerspectiveCamera } from "@react-three/drei";
import { GVarState } from "../StoreState/Gstate";
import LoadScene from "./LoadScene";
import DropDownFloor from "../Compo/DropDownFloor";
import SearchWeb from "../Compo/SearchWeb";
import NextPre from "../NextAndPre/NextPre";
import { responsive } from "../Action/Action";
import PortraitMenu from "../Portrait/PortraitMenu";
import MscerHeader from "../Compo/mscer/MscerHeader";
import MscerFooter from "../Compo/mscer/MscerFooter";
import TiltViewAdmin from "../Compo/tilt_view_admin/TiltViewAdmin";
// import Compass from "../Compo/Compass";

THREE.Cache.enabled = false

function D3() {
  let g = useContext(GVarState);

  const manRef = useRef()
  const [startPointMan, setstartPointMan] = useState(null)


  useEffect(() => {
    const loader = new THREE.TextureLoader();
    const startPointManLoad = loader.load("/icon/start_point_person.png");
    setstartPointMan(startPointManLoad)
  }, [])

  useEffect(() => {
    responsive();
  }, []);



  useEffect(() => {
    
    if (g.path.length && g.path[0].a.z === g.CurrentFloor && manRef.current && g.mallType !== 'MECSR-event') {
      manRef.current.position.x = g.path[0].b.x / 10
      manRef.current.position.y = 8
      manRef.current.position.z = g.path[0].b.y / 10
      manRef.current.visible = true
    } else {
      if (manRef.current) {
        manRef.current.visible = false
      }
    }
  }, [g.path, manRef, g.CurrentFloor])


  return (
    <div className="h-screen w-screen">
      <Canvas
        flat
        gl={{ antialias: true }}
        dpr={window.devicePixelRatio}
      >
        <Camera />
        <color attach="background" args={["white"]} />
        <ambientLight color="0x000000 " />
        <pointLight color="0xffffff" intensity={0.1} position={[0, 500, 0]} />
        <React.Suspense fallback={<Html>Loading...</Html>}>
          <LoadScene />
          <sprite position={[0, -2, 0]} ref={manRef} scale={3} visible={false}>
            {startPointMan &&
              <spriteMaterial attach="material" map={startPointMan} />
            }
          </sprite>
        </React.Suspense>
        <OrbitControls
        ref={g.controllerRef}
          makeDefault
          maxPolarAngle={Math.PI / 3}
          target={[0, 0, 0]}
          enableDamping={false}
          mouseButtons={{
            LEFT: THREE.MOUSE.PAN,
            MIDDLE: THREE.MOUSE.DOLLY,
            RIGHT: THREE.MOUSE.ROTATE,
          }}
          screenSpacePanning={false}
          touches={{
            ONE: THREE.TOUCH.PAN,
            TWO: THREE.TOUCH.DOLLY_ROTATE,
          }}
          maxDistance={800}
          minDistance={30}
        />
      </Canvas>


      {g.path.length > 0 && g.NextPrev?.length > 1 && !g.Device && <NextPre />}
      {!g.Device &&
        <>
          <div className="portrait">
            <PortraitMenu />
            {window.innerWidth < window.innerHeight &&
              <DropDownFloor mobile={true} />
            }
          </div>
          {/*  */}
          <div className="landscape">
            {g.mallType === 'MECSR-event' &&
              <MscerHeader />
            }
            {window.innerWidth > window.innerHeight &&
              <DropDownFloor mobile={false} />
            }
            <SearchWeb />
            {g.mallType === 'MECSR-event' &&
              <MscerFooter />
            }
          </div>
        </>
      }
      {/* <Compass /> */}

      {g.showTiltAdmin && <TiltViewAdmin />}
    </div>
  );
}


let Camera = () => {
  let { aspect, size } = useThree()
  const pixelToThreeUnitRatio = 1
  const planeDistance = 0
  const cameraDistance = 500
  const distance = cameraDistance - planeDistance
  const height = size.height / pixelToThreeUnitRatio
  const halfFovRadians = Math.atan((height / 2) / distance)
  const fov = 2 * halfFovRadians * (180 / Math.PI)
  let g = useContext(GVarState);



  return (
    <PerspectiveCamera
      makeDefault
      position={[0, 150, 70]}
      aspect={aspect}
      fov={fov}
      ref={g.cameraRef}
    />
  )
}

export default D3;


